import { atom } from "jotai";

// [-90, 0, -180, 0, -270]のように複数の画像の回転角度を保持する
// 保持する回転角度の数は変動する
export const rotateDegreeAtom = atom<number[]>([]);
rotateDegreeAtom.debugLabel = "rotateDegreeAtom";
